
import '../../../../Common/js/util/queryStringHelper'; 
import { isNullOrUndefined } from 'util';

$(() => {
  const GUIDEDSERVICES = {
    objectifyForm: function objectifyForm(formArray) {
      let i; // serialize data function
      const returnArray = {};
      returnArray['__RequestVerificationToken'] = '';
      returnArray['searchResultsRendering'] = '';
      returnArray['searchSettingsItemId'] = '';
      returnArray['searchResultsPage'] = '';
      returnArray['filterSelections'] = '';
      returnArray['search'] = '';

      for (i = 0; i < formArray.length; i++) {
        if (formArray[i].name === '__RequestVerificationToken'){
          returnArray[formArray[i].name] = formArray[i].value;
        } 
        if (formArray[i].name === 'searchResultsRendering'){
          returnArray[formArray[i].name] = formArray[i].value;
        } 
        if (formArray[i].name === 'searchSettingsItemId'){
          returnArray[formArray[i].name] = formArray[i].value;
        }
        if (formArray[i].name === 'searchResultsPage'){
          returnArray[formArray[i].name] = formArray[i].value;
        }
        if (formArray[i].name === 'filterSelections'){
          returnArray[formArray[i].name] = formArray[i].value;
        }
        if (formArray[i].name === 'search'){
          returnArray[formArray[i].name] = formArray[i].value;
        }
      }
      return returnArray;
    },
    appendFormVerificationToken: function appendFormVerificationToken($formEl, argsObj) {
      const resultObj = argsObj;
      const verficationTokenEl = ($formEl && $formEl.find('input[name="__RequestVerificationToken"]')) ? $formEl.find('input[name="__RequestVerificationToken"]') : '';
      if (verficationTokenEl) {
        resultObj[verficationTokenEl.attr('name')] = verficationTokenEl.val();
      }
      return resultObj;
    },
    initialisePagination: function initialisePagination($paginationEl) {
      if ($paginationEl) {
        $paginationEl.each(function () {
          $paginationEl.find('.pagination__item:first-child').addClass('active');
          const pages = $paginationEl.find('.pagination__item');
          if (pages && pages.length > 7) {
            for (var i = 0; pages.length > i; i++) {
              if (i > 2 && i != pages.length - 1) {
                $(pages[i]).hide();
              }
            }
            $(pages[2]).after('<li class="pagination__item"><span class="pagination__text">. . .</span></li>');
          }

          $paginationEl.find('.pagination__list').append('<li class="pagination__item next"><a class="pagination__link" href="" aria-label="Next page" data-page-number="2"></a></li>');
        });
      }
    },
    formSubmissionEvent: function formSubmissionEvent($formEl) {
      if ($formEl) {
        $formEl.on('submit', function (e) {
          e.preventDefault();

          const formData = GUIDEDSERVICES.objectifyForm($(this).serializeArray());
          const searchListing = $(this).closest('.search-listing');
          const searchResults = searchListing.find('.search-listing--results');
          const searchResultsCount = searchListing.find('.search-listing--updated');

          if (formData == null || formData.length === 0) {
            console.log('error', 'No form data to post');
            return;
          }

          if (searchListing == null || searchListing.length === 0) {
            console.log('error', 'Search Listings container not found');
            return;
          }

          if (searchResults == null || searchResults.length === 0) {
            console.log('error', 'Search Results container not found');
            return;
          }

          formData.searchResultsPage="1";

          // Ajax request
          $.ajax({
            url: $(this).data('postAction'),
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded; charset=utf-8',
            data: GUIDEDSERVICES.appendFormVerificationToken($(this), formData),
            success: (result) => GUIDEDSERVICES.displayResult(result, searchResults)
          }).fail(function (error) {
            // Failure
            window.console && console.log('error', error);
          });
        });
      }
    },
    listingsClickEvent: function listingsClickEvent($resultsEl) {
      if ($resultsEl) {
        $resultsEl.on('click', '.pagination__link', function (e) {
          e.preventDefault();

          const searchListing = $(this).closest('.search-listing');
          const searchForm = searchListing.find('.search-listing--form');
          const searchResults = searchListing.find('.search-listing--results');

          if (searchListing == null || searchListing.length === 0) {
            console.log('error', 'Search Listings container not found');
            return;
          }

          if (searchResults == null || searchResults.length === 0) {
            console.log('error', 'Search Results container not found');
            return;
          }

          if (searchForm == null || searchForm.length === 0) {
            console.log('error', 'Search Form container not found');
            return;
          }

          const pageField = searchForm.find('#searchResultsPage');

          if (pageField != null && pageField.length !== 0) {
            pageField.val($(this).data('pageNumber'));
          }

          const formData = GUIDEDSERVICES.objectifyForm(searchForm.serializeArray());

          if (formData == null || formData.length === 0) {
            console.log('error', 'No form data to post');
            return;
          }

          // Ajax request
          $.ajax({
            url: searchForm.data('postAction'),
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded; charset=utf-8',
            data: GUIDEDSERVICES.appendFormVerificationToken($(this), formData),
            success: (result) => GUIDEDSERVICES.displayResult(result, searchResults, pageField)
          }).fail(function (error) {
            // Failure
            window.console && console.log('error', error);
          });
        });
      }
    },
    displayResult: function displayResult(result, searchResults, pageField) {
      if (result === '') {
        // empty string results will occur if the post fails anti-forgery check
        console.log('result was null');
        return;
      }
      
      var pageFieldInt = 1;
      
      if (pageField != 'undefined' && pageField != null) {
        pageFieldInt = parseInt(pageField.val());
      }
      if (result) {
        console.log('result was not null');
        if (result.IsSuccessful){
          console.log('result was successful');
          searchResults.html(result.Data);
          const pages = searchResults.find('.pagination__item');
          const current = pageFieldInt - 1;
          $(pages[current]).addClass('active');

          if (pages.length > 7) {
            var start = 3
            var end = pages.length - 1;
            if (current > 2 && current < 5) {
              start = current + 1;
            } else if (current > pages.length - 4 && current < pages.length - 1) {
              end = current;
            }
            for (var i = start; end > i; i++) {
              $(pages[i]).hide();
            }

            $(pages[current]).show();

            if ((current < 5 && current > 1) || (current > 4 && current < pages.length - 3)) {
              $(pages[current]).after('<li class="pagination__item"><span class="pagination__text">. . .</span></li>');
            }
            if (current > 4 && current < pages.length) {
              $(pages[current]).before('<li class="pagination__item"><span class="pagination__text">. . .</span></li>');
            }
            if (current <= 1 || (current < 6 && current > pages.length - 2)) {
              $(pages[2]).after('<li class="pagination__item"><span class="pagination__text">. . .</span></li>');
            }
          }

          if (pageFieldInt < pages.length) {
            var next = pageFieldInt + 1;
            const paginationList = searchResults.find('.pagination__list');
                             
            // paginationList.find('.pagination__item.next').remove();
            paginationList.append('<li class="pagination__item next"><a class="pagination__link" href="" aria-label="Next page" data-page-number="' + next + '"></a></li>');
          }

          if (pageFieldInt != 1) {
            var prev = pageFieldInt - 1;
            const paginationList = searchResults.find('.pagination__list');
            // paginationList.find('.pagination__item.prev').remove();
            paginationList.prepend('<li class="pagination__item prev"><a class="pagination__link" href="" aria-label="Previous page" data-page-number="' + prev + '"></a></li>')
          }

          $("html, body").animate({
            scrollTop: searchResults.offset().top - 200
          }, 300);
        } else{
          searchResults.html(result.Data);
        }             
      }
    },
    activateQueryStringSearch() {
      var queryKey = getQueryStringFullKeyName('rsl_metakeywords_calc');
      if (!isNullOrUndefined(queryKey)) {
        $('.sentence-dropdown-slide').addClass('done');
        $('.sentence-dropdown-slide').removeClass('active');
        $(".sentence-dropdown-progress-item").addClass("done");
        var queryVal = getQueryStringParameterValue(queryKey);

        if ($('.sentence-dropdown-slide .choices__item').length) {
          $('.sentence-dropdown-slide .choices__item.choices__item--choice.choices__item--selectable[data-value="'+queryVal+'"]').closest('.sentence-dropdown-slide').addClass('active');
          $('.sentence-dropdown-slide.active').removeClass('done');

          var optionText = $('.sentence-dropdown-slide.active .choices__item.choices__item--choice.choices__item--selectable[data-value="'+queryVal+'"]').text();
          $('.sentence-dropdown-slide.active .choices__list.choices__list--single .choices__item').text(optionText);
          $('.sentence-dropdown-slide.active .choices__list.choices__list--single .choices__item').attr("data-value",queryVal);
        } else {
          $('.sentence-dropdown-slide select option[value="'+queryVal+'"]').closest('.sentence-dropdown-slide').addClass('active');
          $('.sentence-dropdown-slide.active').removeClass('done');

          $('.sentence-dropdown-slide.active select option[value="'+queryVal+'"]').prop('selected', true);
          $('.sentence-dropdown-slide.active select[value="'+queryVal+'"]').text();
        }
        
        var filterSelectionsVal = $('.sentence-dropdown-slide.active select').first().attr('id') + '=' + queryVal;
        $('#filterSelections').val( filterSelectionsVal);
      }
    },
    init() {
      const $formEl = $('.search-listing--form');
      const $resultsEl = $('.search-listing--results');
      const $paginationEl = $('.pagination');
      if ($formEl && $formEl.length > 0) {
        GUIDEDSERVICES.formSubmissionEvent($formEl);
      }
      if ($resultsEl && $resultsEl.length > 0) {
        GUIDEDSERVICES.listingsClickEvent($resultsEl);
      }
      if ($paginationEl && $paginationEl.length > 0) {
        GUIDEDSERVICES.initialisePagination($paginationEl);
      }
      GUIDEDSERVICES.activateQueryStringSearch();
    }
  };
  GUIDEDSERVICES.init();
});